import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import { CreateMatchData } from "features/navigation/components/side-bar/session-players/AddPlayerForm";

const BASE_URL = "/matches";

export const fetchMatches = createAsyncThunk("matches/get", async () => {
  try {
    const requestUrl = `${BASE_URL}`;
    const response = await axios.get(requestUrl);
    return response.data.data;
  } catch (error: any) {
    console.log("Error - fetchMatches ->", error);
    throw new Error(error.message);
  }
});

export const createMatch = createAsyncThunk(
  "matches",
  async (data: CreateMatchData) => {
    try {
      const requestUrl = `${BASE_URL}`;
      const response = await axios.post(requestUrl, data);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);

export const deleteMatch = createAsyncThunk(
  "matches/delete",
  async (matchId: string) => {
    try {
      const requestUrl = `${BASE_URL}/${matchId}`;
      const response = await axios.delete(requestUrl);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);

export const endMatch = createAsyncThunk(
  "matches/end",
  async (matchId: string) => {
    try {
      const requestUrl = `${BASE_URL}/end/${matchId}`;
      const response = await axios.post(requestUrl);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);
